import React from "react";
import styles from "./Wrapper.module.scss";
import { Empty } from "antd";

const DashboardTableWrapper = ({ data, children, desc, label, loader,totalAverage }) => {
	return (
		<div className={styles.card}>
			<h3>{label}</h3>
			<p>{desc}</p>

			{loader ? (
				<div className={styles.loaderBlock}>
					<div className="graph-loader">
						<div className="loader"></div>
					</div>
				</div>
			) :totalAverage && totalAverage > 0  ? (
				<div className={styles.sourceList}>{children}</div>
			) : (
				<div className={styles.noData}>
					<Empty />
				</div>
			)}
		</div>
	);
};

export default DashboardTableWrapper;
